import { createReducer } from '@reduxjs/toolkit';
import set from 'lodash/set';

import {
  changeCampaign,
  clearHighlightedSKUsForProductsUsingCollectionIds,
  push,
  submit,
} from '../actions';

export default createReducer(
  {},
  /* eslint-disable no-param-reassign */
  {
    [changeCampaign]: (state, { payload: { name, value } }) => {
      set(state, name, value);
    },

    [clearHighlightedSKUsForProductsUsingCollectionIds]: (
      state,
      { payload: { productCodesToClean } },
    ) => {
      productCodesToClean.forEach(code => {
        state.highlightedSkus[code] = [];
      });
    },

    [`${submit}-success`]: (state, { payload }) => payload.campaign,
    [`${push}-success`]: (state, { payload }) => payload.campaign,
  },
  /* eslint-enable no-param-reassign */
);
